<template>
  <div style="width:100%">
    <div style="padding:20px">

      <div >
        <div style="float: left;font-weight: 500">考试信息</div>

        <el-button style="margin-left: 20px;margin-top: -10px;" type="primary" @click="updateExerciseTemplate">
          修改信息
        </el-button>
      </div>
      <div style="clear: both;"></div>

      <el-form style="margin-top: 30px;" class="templateForm" label-position="left" label-width="130px">

        <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="试卷模板">
                <el-input v-model="templateForm.template_name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
               <el-form-item label="所属业务" prop="test_BU">
                  <el-select
                      class="w140"
                      v-model="templateForm.test_BU"
                      placeholder="请选择试卷所属业务"
                      clearable
                      @change="handleBUChange"
                  >
                    <el-option
                        v-for="item in BUOptions"
                        :key="item.name"
                        :label="item.name"
                        :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
            </el-col>
        </el-row>

        <el-col :span="24">
          <el-col :span="12">
            <el-form-item label="试卷主题">
              <el-input v-model="templateForm.test_subject"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="项目代码" prop="project_code">

              <el-input v-model="templateForm.project_code"></el-input>

              <!-- <el-select v-model="templateForm.project_code" style="width: 300px" @change="handleProjectCodeChanged">
                <el-option v-for="(project,index) in projects" :value="project.project_code"
                          :label="project.project_code" :key="index"></el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
        </el-col>

        <el-col :span="24">
          <el-col :span="12">
            <el-form-item label="记分方式">
              <el-select v-model="templateForm.keep_score_type">
                <el-option value="real_time" label="real_time"></el-option>
                <el-option value="post_exam" label="post_exam"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="试卷类型" prop="test_type">
              <el-select
                  class="w140"
                  v-model="templateForm.test_type"
                  placeholder="请选择试卷类型"
                  clearable
              >
                <el-option
                    v-for="item in typeOptions"
                    :key="item.name"
                    :label="item.name"
                    :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="试卷难度" prop="difficulty_level">
              <el-select
                  class="w140"
                  v-model="templateForm.difficulty_level"
                  placeholder="请选择试卷难度"
                  clearable
              >
                <el-option
                    v-for="item in [0,1,2,3,4,5,6]"
                    :key="item"
                    :label="item"
                    :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="允许重考">
              <el-select v-model="templateForm.allow_retake">
                <el-option value="NO" label="NO"></el-option>
                <el-option value="YES" label="YES"></el-option>

              </el-select>
            </el-form-item>
          </el-col>
        </el-col>

        <el-col :span="24">
          <el-col :span="12">
            <el-form-item label="考试时长(分钟)">
              <el-input-number
                  v-model="templateForm.test_duration"
                  :min="1"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="考试形式">
              <el-select v-model="templateForm.exam_type">
                <el-option value="individual" label="individual"></el-option>
                <el-option value="team" label="team"></el-option>
                <el-option v-if="templateForm.test_BU === 'AM'" value="relay" label="relay"></el-option>
                <el-option v-else value="Relay" label="Relay"></el-option>
              </el-select>
              <div v-if="templateForm.test_BU === 'AM'" style="color: #909399; line-height: 20px; margin-top: 4px;">
                relay：团队接力；individual：个人顺序完成 5 个模块（每模块 2 小时，总窗口 24 小时）。
              </div>
            </el-form-item>
          </el-col>
        </el-col>

        <el-col :span="24">
          <el-col :span="12">
            <el-form-item label="答错扣分">
              <el-select v-model="templateForm.answer_deduction_points">
                <el-option value="NO" label="NO"></el-option>
                <el-option value="YES" label="YES"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="考试总分">
              <el-input type="number" v-model="templateForm.full_score"></el-input>
            </el-form-item>
          </el-col>
        </el-col>

        <el-col :span="24">
          <el-col :span="12">
            <el-form-item label="单题分值">
              <el-input
                  type="number"
                  v-model="templateForm.question_marks"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">

            <el-form-item label="初始分值">
              <el-input type="number" v-model="templateForm.initial_score"></el-input>
            </el-form-item>

          </el-col>
        </el-col>

        <el-col :span="24">
          <el-col :span="12">
            <el-form-item label="是否播放讲座视频">
                <el-select v-model="templateForm.show_lecture" placeholder="请选择">
                    <el-option value="YES" label="是"></el-option>
                    <el-option value="NO" label="否"></el-option>
                </el-select>
            </el-form-item>
          </el-col>
        </el-col>

        <!-- <el-form-item label="Banner">
          <img :src="image" @click="uploadHeadImg" style="width:200px"/>
          <input
              type="file"
              ref="file"
              accept="image/*"
              class="hiddenInput"
              @change="handleFile"
          />
          <div style="width:140px;text-align:center">
            <el-button type="warning" @click="uploadBanner" size="mini"
            >提交
            </el-button
            >
          </div>
        </el-form-item> -->
        <!-- <el-form-item label="模板主题">
          <el-select v-model="templateForm.test_subject" style="width: 400px">
            <el-option v-for="(event,index) in events" :key="index" :value="event"
                       :label="event"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="主题(自定义)">
          <el-input placeholder="请填写自定义主题"  v-model="custom_test_subject"></el-input>
          <p>优先取自定义主题，如果自定义主题没有设置，就取选择的主题</p>
        </el-form-item> -->
        <!-- <el-form-item label="模板介绍">
          <el-input
              type="textarea"
              :rows="5"
              v-model="templateForm.template_instruction"
              style="width:80%"
          ></el-input>
        </el-form-item> -->

        <!-- <el-form-item label="考试时间">
          <el-input v-model="templateForm.test_time"></el-input>
        </el-form-item> -->

        <el-col :span="24">
          <el-form-item label="节前指示">
            <el-button type="primary" size="small" @click="showSectionInstruction = !showSectionInstruction">
              {{ showSectionInstruction ? '收起编辑' : '打开编辑' }}
            </el-button>
            <div v-if="showSectionInstruction" style="margin-top: 12px;">
              <tinymce :height="380" v-model="templateForm.section_list_instruction"/>
            </div>
          </el-form-item>
        </el-col>
      </el-form>

      <div >
        <div style="float: left;font-weight: 500;">试卷内容</div>

        <el-button style="margin-left: 20px;margin-top: -10px;"  type="primary" @click="updateRedisExerciseTemplate">
          更新服务器试卷
        </el-button>

        <p style="margin-top: 10px;">请注意：修改试卷信息 题目 等信息后 需要进行更新服务器试卷</p>
        <p style="color:red">请注意：PDF要么用通用字体全部，用特殊字体就得传图片格式的PDF,文件限制上传单页不能超过500KB！！！</p>

      </div>
      <div style="clear: both;"></div>

      <div style="margin-top: 30px;">
        <span style="margin-right: 10px;">图片/PDF列表</span>
        <el-button type="primary" size="small" @click="showPicArrEditor = !showPicArrEditor">
          {{ showPicArrEditor ? '收起编辑' : '打开编辑' }}
        </el-button>
        <div v-if="showPicArrEditor" style="margin-top: 12px;">
          <p style="margin: 0 0 8px;color: #909399;">一行放一个，回车换行，不留空格</p>
          <el-input
              type="textarea"
              :rows="5"
              v-model="templateForm.pic_arr_str"
              style="width:80%"
          ></el-input>
        </div>
      </div>

      <div class="html-materials-panel">
        <div class="html-materials-header">
          <span>HTML富文本列表（当 pdf 加载失败时，需要显示 html 富文本）</span>
          <el-button type="primary" size="small" @click="addHtmlMaterial">添加富文本</el-button>
        </div>
        <div class="html-materials-body">
          <div class="html-materials-editor">
            <template v-if="activeHtmlMaterial">
              <div class="html-material-meta">
                当前 ID：<code>{{ activeHtmlMaterial.id }}</code>
              </div>
              <tinymce
                :key="'html-material-' + activeHtmlMaterial.id"
                :id="'html-material-editor-' + activeHtmlMaterial.id"
                :height="320"
                v-model="activeHtmlMaterial.content"
              />
            </template>
            <div v-else class="html-materials-empty">
              暂无富文本，请在右侧列表中添加
            </div>
          </div>
          <div class="html-materials-sidebar">
            <div class="html-materials-sidebar-title">富文本列表</div>
            <div
              v-for="(htmlInfo, index) in templateForm.html_materials"
              :key="htmlInfo.id || ('html-material-' + index)"
              :class="['html-material-item', { active: htmlInfo.id === activeHtmlMaterialId }]"
              @click="selectHtmlMaterial(htmlInfo.id)"
            >
              <div class="html-material-item-main">
                <div class="html-material-item-title">{{ htmlInfo.id }}</div>
                <div class="html-material-item-id">富文本 {{ index + 1 }}</div>
              </div>
              <el-button
                type="danger"
                size="mini"
                plain
                @click.stop="removeHtmlMaterial(htmlInfo.id)"
              >删除</el-button>
            </div>
            <div v-if="!(templateForm.html_materials && templateForm.html_materials.length)" class="html-materials-sidebar-empty">
              暂无条目
            </div>
          </div>
        </div>
      </div>

      <p style="margin-top: 10px;">模块列表</p>
      <el-button type="primary" @click="initAdd" size="medium"
      >添加模块
      </el-button
      >
      <el-button type="primary" @click="sort" size="medium">排序</el-button>
      <el-table :data="sections">
        <el-table-column
            label="副标题"
            prop="section_subtitle"
            width="150px"
        ></el-table-column>
        <el-table-column
            label="标题"
            prop="section_title"
            width="400px"
        ></el-table-column>
        <!-- <el-table-column label="说明" prop="section_instruction"></el-table-column> -->
        <!-- <el-table-column label="材料类型" prop="section_material_type" width="100"></el-table-column> -->
        <!-- <el-table-column label="材料" prop="section_material"></el-table-column> -->
        <el-table-column>
          <template slot-scope="scope">
            <el-button
                type="primary"
                size="mini"
                @click="viewSection(scope.row)"
            >编辑
            </el-button
            >
            <el-button
                type="primary"
                size="mini"
                @click="viewSectionPics(scope.row)"
            >材料图片
            </el-button
            >
            <el-button
                type="primary"
                size="mini"
                @click="viewQuestion(scope.row._id.$id)"
            >查看题目列表
            </el-button
            >
            <el-button
                type="danger"
                size="mini"
                @click="removeExerciseSection(scope.row._id.$id)"
            >删除
            </el-button
            >
            <el-button type="primary" size="mini" @click="picSync(scope.row)"
            >同步图片
            </el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="添加Section" :visible.sync="showSection">
      <el-form>
        <el-form-item label="副标题">
          <el-input v-model="sectionForm.section_subtitle"></el-input>
        </el-form-item>
        <el-form-item label="标题">
          <el-input v-model="sectionForm.section_title"></el-input>
        </el-form-item>
        <el-form-item label="说明">
          <el-input v-model="sectionForm.section_instruction"></el-input>
        </el-form-item>
        <el-form-item label="材料类型">
          <el-select v-model="sectionForm.section_material_type">
            <el-option value="audio" label="音频"></el-option>
            <el-option value="text" label="文字"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="材料">
          <tinymce :height="250" v-model="sectionForm.section_material"/>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="updateExerciseTemplateSection"
      >确定
      </el-button
      >
    </el-dialog>

    <el-dialog
        title="管理Section材料图片"
        :visible.sync="showSectionPics"
        width="80%"
    >
      <el-form>
        <el-form-item label="图片列表">
          <div style="margin-bottom:20px;">
            <input type="file" ref="file" accept="image/*" multiple/>
            <el-button
                size="small"
                @click="handleSectionPicUpload(sectionForm._id.$id)"
                type="primary"
            >确认上传
            </el-button
            >
          </div>
          <img
              v-for="item in sectionForm.pic_arr"
              :key="item"
              :src="'http://' + item"
              style="width:105px;height:150px;cursor:pointer;marign:2px;border:1px dotted lightGray"
              @click="removeSectionPic(item, sectionForm._id.$id)"
          />
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="排序" :visible.sync="showSort" @opened="initSort">
      <div id="foo">
        <div v-for="item in sortData" :key="item._id.$id" class="item">
          {{ item.section_title }}
        </div>
      </div>
      <el-button @click="sortSection" type="primary">确定</el-button>
    </el-dialog>

    <el-dialog :visible.sync="showReviewPdfDialog" :modal="true" :show-close="false"
               :modal-append-to-body="true"
               custom-class="showReviewPdfDialogStyle">
      <PreviewPdf :pdf_urls="pdfUrls"></PreviewPdf>
    </el-dialog>

    <el-dialog :visible.sync="showRemoveMultiPicDialog" title="批量删除材料图片">
      <div>
        <el-table :data="picArrs" :border="true" ref="multipleTable"
                  @selection-change="handleRemoveMultiPicSelectionChange" style="max-height: 400px;overflow-y: auto">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" prop="index" label="序号"/>
          <el-table-column prop="" label="材料">
            <template slot-scope="scope">
              <p>{{ scope.row.replace('guomu-content.reachable-edu.com/', '') }}</p>
            </template>
          </el-table-column>
        </el-table>
        <el-button type="success" size="small" style="margin-top: 20px" @click="confirmRemoveMultiPic">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  getExerciseTemplate,
  addExerciseQuestionToTemplate,
  getExerciseQuestions,
  removeExerciseQuestionInTemplate,
  resortQuestionsInTemplate,
  updateExerciseTemplate,
  uploadBanner,
  updateExerciseTemplateSection,
  removeExerciseSection,
  sortSection,
  uploadPicBatch,
  uploadSectionPicBatch,
  removePic,
  removeSectionPic,
  delTemplateRedis,
  changeIndexPic,
  removeMultiPics, getProjects
} from '../api/examAdmin'
import Template from './Template.vue'
import Tinymce from '../components/Tinymce'
import Sortable from 'sortablejs'
import VueTagsInput from '@johmun/vue-tags-input'
import PreviewPdf from '../components/PreviewPdf'

export default {
  components: {
    PreviewPdf,
    VueTagsInput,
    Template,
    tinymce: Tinymce
  },
  data () {
    return {
      removeMultiPics: [],
      showRemoveMultiPicDialog: false,
      tag: '',
      tags: [],
      template_id: this.$route.query.template_id,
      sections: [],
      questions_all: [],
      showAdd: false,
      showSection: false,
      showSectionPics: false,
      sectionForm: {
        _id: { $id: '' },
        section_title: '',
        section_instruction: '',
        section_material: '',
        section_material_type: ''
      },
      currentRow: {},
      templateForm: {
        achieve_arr: [],
        html_materials: []
      },
      image: '',
      searchForm: {},
      BUOptions: [
        {
          name: 'AM'
        },
        {
          name: 'ETA'
        },
        {
          name: 'FBLA'
        },
        {
          name: 'FELC'
        },
        {
          name: 'WEC'
        },
        {
          name: 'IBO'
        },
        {
          name: 'CEO'
        },
        {
          name: 'IPSYO'
        },
        {
          name: 'WAO'
        },
        {
          name: 'ICS'
        }
      ],
      typeOptions: [
        {
          name: 'formal_test'
        },
        {
          name: 'mock_test'
        },
        {
          name: 'sample_test'
        },
        {
          name: 'special_exercise'
        }
      ],
      showSort: false,
      sortData: [],
      picArrs: [],
      picNameArrs: [],
      ws: null,
      pdfUrls: [],
      showReviewPdfDialog: false,
      events: [],
      projects: [],
      custom_test_subject: '',
      showSectionInstruction: false,
      showPicArrEditor: false,
      activeHtmlMaterialId: ''
    }
  },
  computed: {
    activeHtmlMaterial () {
      const list = this.templateForm.html_materials || []
      return list.find(item => item && item.id === this.activeHtmlMaterialId) || null
    }
  },
  mounted () {
    this.onConnect()
    this.requestProjects()
  },
  methods: {
    handleBUChange (bu) {
      if (String(this.templateForm.exam_type || '').toLowerCase() === 'relay') {
        this.$set(this.templateForm, 'exam_type', bu === 'AM' ? 'relay' : 'Relay')
      }
    },

    createHtmlMaterialId () {
      return this.nextHtmlMaterialId()
    },

    isValidHtmlMaterialId (id) {
      return /^M\d+$/i.test(String(id || ''))
    },

    nextHtmlMaterialId () {
      const list = this.templateForm.html_materials || []
      let max = 0
      list.forEach((item) => {
        const matched = String(item && item.id ? item.id : '').match(/^M(\d+)$/i)
        if (matched) {
          max = Math.max(max, parseInt(matched[1], 10))
        }
      })
      return 'M' + (max + 1)
    },

    normalizeHtmlMaterials () {
      if (!Array.isArray(this.templateForm.html_materials)) {
        this.$set(this.templateForm, 'html_materials', [])
      }

      let max = 0
      this.templateForm.html_materials.forEach((item) => {
        const matched = String(item && item.id ? item.id : '').match(/^M(\d+)$/i)
        if (matched) {
          max = Math.max(max, parseInt(matched[1], 10))
        }
      })

      this.templateForm.html_materials.forEach((item) => {
        if (this.isValidHtmlMaterialId(item.id)) {
          const matched = String(item.id).match(/^M(\d+)$/i)
          this.$set(item, 'id', 'M' + matched[1])
        } else {
          max += 1
          this.$set(item, 'id', 'M' + max)
        }
        if (item.content === undefined || item.content === null) {
          this.$set(item, 'content', '')
        }
      })

      if (!this.templateForm.html_materials.length) {
        this.activeHtmlMaterialId = ''
        return
      }

      const stillExists = this.templateForm.html_materials.some(
        item => item.id === this.activeHtmlMaterialId
      )
      if (!stillExists) {
        this.activeHtmlMaterialId = this.templateForm.html_materials[0].id
      }
    },

    selectHtmlMaterial (id) {
      this.activeHtmlMaterialId = id
    },

    addHtmlMaterial () {
      if (!Array.isArray(this.templateForm.html_materials)) {
        this.$set(this.templateForm, 'html_materials', [])
      }
      const id = this.nextHtmlMaterialId()
      this.templateForm.html_materials.push({
        id,
        content: ''
      })
      this.activeHtmlMaterialId = id
    },

    removeHtmlMaterial (id) {
      const list = this.templateForm.html_materials || []
      const index = list.findIndex(item => item.id === id)
      if (index < 0) {
        return
      }

      this.$confirm('确定删除该富文本吗？删除后需点击「修改信息」才会保存。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        list.splice(index, 1)
        if (this.activeHtmlMaterialId === id) {
          this.activeHtmlMaterialId = list.length ? list[Math.min(index, list.length - 1)].id : ''
        }
        this.$message.success('已删除，请记得点击「修改信息」保存')
      }).catch(() => {})
    },

    handleProjectCodeChanged (e) {
      this.events = []
      this.templateForm.test_subject = ''
      this.custom_test_subject = ''
      for (let i = 0; i < this.projects.length; i++) {
        if (this.projects[i].project_code == this.templateForm.project_code) {
          if (this.projects[i].event_number_string) {
            const event_award_modes_string = this.projects[i].event_number_string
            const values = event_award_modes_string.split('\r\n')
            for (let j = 0; j < values.length; j++) {
              this.events.push(values[j].split('|')[0])
            }
          }
          break
        }
      }
    },

    async requestProjects () {
      const resut1 = await getProjects('22-23')
      const resut2 = await getProjects('23-24')
      this.projects = resut2.data.concat(resut1.data)
      this.fetchData()
    },

    handleRemoveMultiPicSelectionChange (val) {
      this.removeMultiPics = val
    },

    confirmRemoveMultiPic () {
      if (this.removeMultiPics.length <= 0) {
        this.$message.error('请选择材料图片')
        return
      }
      this.$alert('您确定要删除掉这些材料吗？', '提示', {
        confirmButtonText: '确定',
        callback: action => {
          if (action == 'confirm') {
            removeMultiPics(this.template_id, this.removeMultiPics).then((res) => {
              this.$message.success('删除成功')
              this.fetchData()
              this.showRemoveMultiPicDialog = false
            })
          }
        }
      })
    },
    clickShowRemoveMultiPicDialog () {
      this.removeMultiPics = []
      this.showRemoveMultiPicDialog = true
    },

    onConnect () {
      this.ws = new WebSocket('wss://team-chat.learningfirst.cn:9000')
    },
    searchQuestion () {
      if (!this.searchForm.question_question_string) {
        this.$message.warning('请先输入题目')
      } else {
        getExerciseQuestionsByName({
          search_word: this.searchForm.question_question_string
        }).then(res => {
          if (res.code === 0) {
            this.questions = res.data
          }
        })
      }
    },
    fetchData () {
      getExerciseTemplate(this.template_id).then(res => {
        if (res.data.code === 0) {
          this.templateForm = res.data.data
          if (this.templateForm.test_BU === 'AM' && String(this.templateForm.exam_type || '').toLowerCase() === 'relay') {
            this.$set(this.templateForm, 'exam_type', 'relay')
          }
          if (!this.templateForm.html_materials) {
            this.templateForm.html_materials = []
          }
          this.normalizeHtmlMaterials()
          this.custom_test_subject = ''// this.templateForm.test_subject
          var temp_tags = res.data.data.achieve_arr
            ? res.data.data.achieve_arr
            : []
          this.tags = []
          for (var i = 0; i < temp_tags.length; i++) {
            var tag = { text: temp_tags[i] }

            this.tags.push(tag)
          }
          this.picArrs = res.data.data.pic_arr ? res.data.data.pic_arr : []

          var picnamearr = []
          for (var i = 0; i < this.picArrs.length; i++) {
            var url = this.picArrs[i]
            var name = url.replace('guomu-content.reachable-edu.com/', '')
            picnamearr.push(name)
          }

          this.picNameArrs = picnamearr

          this.sections = res.data.data.sections_item
          this.image = res.data.data.banner_address
            ? 'http://' + res.data.data.banner_address
            : 'https://wpimg.wallstcn.com/577965b9-bb9e-4e02-9f0c-095b41417191'

          this.events = []
          for (let i = 0; i < this.projects.length; i++) {
            if (this.projects[i].project_code == this.templateForm.project_code) {
              const event_award_modes_string = this.projects[i].event_number_string
              const values = event_award_modes_string.split('\r\n')
              for (let j = 0; j < values.length; j++) {
                this.events.push(values[j].split('|')[0])
              }
              break
            }
          }
        }
      })
    },

    updateRedisExerciseTemplate () {
      delTemplateRedis(this.template_id).then(res => {
        this.$message('更新成功')
      })
    },
    updateExerciseTemplate () {
      var temp_tags = []
      for (var i = 0; i < this.tags.length; i++) {
        temp_tags.push(this.tags[i].text)
      }
      // let test_subject = this.templateForm.test_subject
      let test_subject = this.custom_test_subject
      if (!test_subject || test_subject == '' || test_subject == undefined || test_subject == null) {
        test_subject = this.templateForm.test_subject
      }
      const isRelay = String(this.templateForm.exam_type || '').toLowerCase() === 'relay'
      const examType = isRelay
        ? (this.templateForm.test_BU === 'AM' ? 'relay' : 'Relay')
        : this.templateForm.exam_type
      this.normalizeHtmlMaterials()
      updateExerciseTemplate(
        this.template_id,
        this.templateForm.template_name,
        test_subject,
        // this.templateForm.template_instruction,
        '',
        this.templateForm.test_duration,
        this.templateForm.test_type,
        this.templateForm.test_BU,
        // this.templateForm.test_time,
        '',
        this.templateForm.project_code,
        this.templateForm.full_score,
        this.templateForm.question_marks,
        this.templateForm.section_list_instruction,
        temp_tags,
        this.templateForm.initial_score,
        this.templateForm.keep_score_type,
        examType,
        this.templateForm.answer_deduction_points,
        this.templateForm.pic_arr_str,
        this.templateForm.difficulty_level,
        this.templateForm.allow_retake,
        this.templateForm.html_materials ? this.templateForm.html_materials : [],
        this.templateForm.show_lecture
      ).then(res => {
        if (res.data.code === 0) {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.fetchData()
        }
      })
    },
    addExerciseQuestionToTemplate (question_id) {
      addExerciseQuestionToTemplate(question_id, this.template_id).then(res => {
        if (res.data && res.data.code === 0) {
          this.$message({
            message: '添加成功',
            type: 'success'
          })
          this.fetchData()
        } else {
          this.$message('已添加')
        }
      })
    },
    removeExerciseQuestionInTemplate (question_id) {
      removeExerciseQuestionInTemplate(question_id, this.template_id).then(
        res => {
          if (res.data && res.data.code === 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.fetchData()
          }
        }
      )
    },
    viewSection (row) {
      this.sectionForm = row
      if (!this.sectionForm.pic_arr) {
        this.sectionForm.pic_arr = []
      }
      this.showSection = true
    },
    viewSectionPics (row) {
      this.sectionForm = row
      this.showSectionPics = true
    },
    uploadHeadImg () {
      document.querySelector('.hiddenInput').click()
    },
    // 将头像显示
    handleFile (e) {
      const $target = e.target || e.srcElement
      const file = $target.files[0]
      var reader = new FileReader()
      reader.onload = data => {
        const res = data.target || data.srcElement
        this.image = res.result
      }
      reader.readAsDataURL(file)
    },
    uploadBanner () {
      const myfile = this.$refs.file
      const file = myfile.files[0]
      if (!file) {
        this.$message('请上传图片')
        return
      }
      const param = new FormData()
      param.append('file', file)
      param.append('function', 'uploadBanner')
      param.append('template_id', this.template_id)
      uploadBanner(param).then(res => {
        if (res.data.status === 'success') {
          this.$message({
            message: '上传成功',
            type: 'success'
          })
          this.fetchData()
        }
      })
    },
    initAdd () {
      this.sectionForm = {
        _id: { $id: '' },
        section_title: '',
        section_instruction: '',
        section_material: ''
      }
      this.showSection = true
    },
    updateExerciseTemplateSection () {
      updateExerciseTemplateSection(
        this.sectionForm._id.$id,
        this.template_id,
        this.sectionForm.section_title,
        this.sectionForm.section_subtitle,
        this.sectionForm.section_instruction,
        this.sectionForm.section_material,
        this.sectionForm.section_material_type
      ).then(res => {
        if (res.data.code === 0) {
          this.$message({
            message: '更新成功',
            type: 'success'
          })
          this.showSection = false
          this.fetchData()
        }
      })
    },
    removeExerciseSection (section_id) {
      removeExerciseSection(section_id, this.template_id).then(res => {
        if (res.data.code === 0) {
          this.$message({
            message: '更新成功',
            type: 'success'
          })
          this.fetchData()
        }
      })
    },
    viewQuestion (section_id) {
      this.$router.push({
        path: '/sectionInfo',
        query: {
          section_id: section_id,
          template_id: this.template_id
        }
      })
    },
    sort () {
      this.showSort = true
      this.sortData = JSON.parse(JSON.stringify(this.sections))
      console.log(this.sortData)
    },
    initSort () {
      Sortable.create(document.getElementById('foo'), {
        onEnd: e => {
          const currRow = this.sortData.splice(e.oldIndex, 1)[0]
          this.sortData.splice(e.newIndex, 0, currRow)
        }
      })
    },
    sortSection () {
      const ids = this.sortData.map(item => item._id.$id)
      sortSection(this.template_id, ids).then(res => {
        this.$message({
          message: '排序成功',
          type: 'success'
        })
        this.fetchData()
        this.showSort = false
      })
    },
    handleUpload () {
      const form = new FormData()
      const files = this.$refs.file.files
      form.append('function', 'uploadPicBatch')
      form.append('template_id', this.template_id)
      for (let i = 0; i < files.length; i++) {
        form.append(`file${i}`, files[i])
      }
      uploadPicBatch(form).then(res => {
        if (res.data.status === 'success') {
          this.$message.success('上传成功')
          this.fetchData()
        } else {
          this.$message.error('文件上传失败')
        }
      })
    },
    handleSectionPicUpload (section_id) {
      const form = new FormData()
      const files = this.$refs.file.files
      form.append('function', 'uploadSectionPicBatch')
      form.append('section_id', section_id)
      for (let i = 0; i < files.length; i++) {
        form.append(`file${i}`, files[i])
      }
      uploadSectionPicBatch(form).then(res => {
        if (res.data.status === 'success') {
          this.$message.success('上传成功')
          this.fetchData()
        } else {
          this.$message.error('文件上传失败')
        }
      })
    },
    removePic (item) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removePic(item, this.template_id).then(res => {
          this.$message.success('删除成功')
          this.fetchData()
        })
      })
    },
    removeSectionPic (item, section_id) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeSectionPic(item, section_id).then(res => {
          this.$message.success('删除成功')
          this.fetchData()
        })
      })
    },

    moveUp (item, index) {
      if (index != 0) {
        var tem = this.picNameArrs[index - 1]
        this.$set(this.picNameArrs, index - 1, item)
        this.$set(this.picNameArrs, index, tem)

        var openUrl = ''
        if (item.includes('.cn') || item.includes('.com')) {
          openUrl = item
        } else {
          openUrl = 'guomu-content.reachable-edu.com/' + item
        }

        changeIndexPic(openUrl, this.template_id, 'up').then(res => {
          if (res.data.code == 0) {
            this.$message.success('修改成功')
          } else {
            this.$message.error('修改失败')
          }
        })
      }
    },

    moveDown (item, index) {
      if (index < this.picNameArrs.length - 1) {
        var tem = this.picNameArrs[index + 1]
        this.$set(this.picNameArrs, index + 1, item)
        this.$set(this.picNameArrs, index, tem)

        var openUrl = ''
        if (item.includes('.cn') || item.includes('.com')) {
          openUrl = item
        } else {
          openUrl = 'guomu-content.reachable-edu.com/' + item
        }

        changeIndexPic(openUrl, this.template_id, 'down').then(res => {
          if (res.data.code == 0) {
            this.$message.success('修改成功')
          } else {
            this.$message.error('修改失败')
          }
        })
      }
    },

    showDetailUrl (item) {
      var openUrl = ''
      if (item.includes('.cn') || item.includes('.com')) {
        openUrl = item

        if (item.includes('http')) {

        } else {
          openUrl = 'http' + item
        }
      } else {
        openUrl = 'http://guomu-content.reachable-edu.com/' + item
      }
      var urls = []
      urls.push(openUrl)
      this.pdfUrls = urls
      this.showReviewPdfDialog = true

      // this.$router.push('review')

      // window.open(openUrl, "_blank");
    },

    picSync (e) {
      if (this.ws) {
        const obj = JSON.stringify(e)
        this.ws.send(`correctSessionPicSync&${obj}`)
        this.$message.success('同步成功')
      }
    }
  }
}
</script>

<style>
.showReviewPdfDialogStyle {
  width: 70%;
  height: 100vh;
  overflow-y: auto;
  text-align: center;
  background-color: white;
  padding: 0px;
  box-shadow: 0px 0px 0px 0px transparent;
}

/*.el-dialog__header {*/
/*  padding: 0px;*/
/*  margin: 0;*/
/*}*/

/* .el-dialog__body {*/
/*  padding: 0;*/
/*   margin: 0;*/
/*}*/

</style>

<style scoped>

.questionForm .el-input {
  width: 500px;
}

.templateForm .el-input {
  width: 80%;
}

.hiddenInput {
  display: none;
}

.item {
  font-size: 20px;
  margin-bottom: 20px;
}

.html-materials-panel {
  margin-top: 25px;
}

.html-materials-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  font-weight: 500;
}

.html-materials-body {
  display: flex;
  gap: 16px;
  align-items: stretch;
}

.html-materials-editor {
  flex: 1;
  min-width: 0;
  max-width: calc(100% - 280px);
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 12px;
  background: #fff;
  box-sizing: border-box;
}

.html-material-meta {
  margin-bottom: 10px;
  color: #606266;
  font-size: 13px;
}

.html-material-meta code {
  background: #f5f7fa;
  padding: 2px 6px;
  border-radius: 3px;
  color: #409eff;
}

.html-materials-empty,
.html-materials-sidebar-empty {
  color: #909399;
  font-size: 13px;
  padding: 24px 8px;
  text-align: center;
}

.html-materials-sidebar {
  width: 260px;
  flex-shrink: 0;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 10px;
  background: #fafafa;
  max-height: 420px;
  overflow-y: auto;
  box-sizing: border-box;
}

.html-materials-sidebar-title {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #303133;
}

.html-material-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px;
  margin-bottom: 8px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
}

.html-material-item:hover {
  border-color: #c6e2ff;
}

.html-material-item.active {
  border-color: #409eff;
  background: #ecf5ff;
}

.html-material-item-main {
  min-width: 0;
  flex: 1;
}

.html-material-item-title {
  font-size: 13px;
  color: #303133;
  margin-bottom: 4px;
}

.html-material-item-id {
  font-size: 12px;
  color: #909399;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
